// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__397Pw","topBottomGutter":"Layout_topBottomGutter__35Iqi"};